import useGenericRiskActions from './useGenericRiskActions';
import queryContentRisk from './queryContentRisks';

export default function() {
    const fetchFn = (content) => queryContentRisk({ content });

    return useGenericRiskActions(fetchFn);
}
